import styled from 'styled-components';

import { Text } from '../../Text';

import { theme } from '../../../theme';

import { TriangleProps, TipProps, WrapProps } from './types';

const Container = styled.div`
  display: inline-block;
`;

const Hoverable = styled(Container)``;

const TooltipText = styled(Text)`
  color: ${theme.colors.neutral.grey.lightest};
  white-space: pre-line;
  overflow-wrap: break-word;
  display: inline;
`;

const Triangle = styled.div`
  background-color: #333;
  height: 16px;
  width: 16px;
  position: absolute;
  transform: rotate(45deg);
  z-index: 12;
`;

const Tip = styled.div<TipProps & TriangleProps>`
  transition: ${({ duration }) => `opacity ${duration}ms`};

  &.tip-enter {
    opacity: 0;
  }

  &.tip-enter-active {
    opacity: 1;
  }

  &[data-popper-placement^='top-start'] > #veeqo-components-triangle {
    left: 8px;
    bottom: 0px;
  }
  &[data-popper-placement^='top-end'] > #veeqo-components-triangle {
    right: 8px;
    bottom: 0px;
  }

  &[data-popper-placement^='bottom-start'] > #veeqo-components-triangle {
    left: 8px;
    top: -4px;
  }
  &[data-popper-placement^='bottom-end'] > #veeqo-components-triangle {
    right: 8px;
    top: -4px;
  }
`;

const Wrap = styled(Container)<WrapProps>`
  font-size: 14px;
  overflow: hidden;
  padding: 16px 20px;
  border-radius: 4px;
  box-shadow: 0 6px 1em -0.5em rgba(0, 0, 0, 0.35);
  background: #333;
  color: #fff;
  z-index: 10;
  min-width: ${({ tipMinWidth }) => tipMinWidth}px;
  max-width: ${({ tipMaxWidth }) => tipMaxWidth}px;
`;

export { Container, TooltipText, Tip, Hoverable, Wrap, Triangle };
